{
  "devDependencies": {
    "@ast-grep/cli": "^0.40.4",
    "eslint": "^9.39.0",
    "husky": "^8.0.0",
    "prettier": "^3.3.3",
    "typescript": "^6.0.3",
    "@graphql-codegen/cli": "^6.1.0",
    "@graphql-codegen/typescript": "^4.1.6",
    "@graphql-codegen/typescript-operations": "^4.4.2",
    "@graphql-codegen/typescript-react-apollo": "^4.3.4",
    "@react-native-community/cli": "^20.0.2",
    "@react-native-community/cli-platform-android": "^20.0.2",
    "@react-native-community/cli-platform-ios": "^20.0.2",
    "@testing-library/react-native": "^13.0.0",
    "@types/react": "~19.2.15",
    "@types/react-dom": "~19.2.3",
    "expo-atlas": "^0.4.0",
    "jest-expo": "~57.0.5",
    "@babel/core": "^7.29.0",
    "@babel/plugin-proposal-export-namespace-from": "^7.18.9",
    "@codyswann/lisa": "4.66.4",
    "@commitlint/cli": "^20.3.1",
    "@commitlint/config-conventional": "^20.3.1",
    "@eslint-community/eslint-plugin-eslint-comments": "^4.5.0",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.39.0",
    "@figma/code-connect": "^1.5.2",
    "@jest/globals": "^30.0.0",
    "@jest/test-sequencer": "^30.2.0",
    "@lhci/cli": "^0.15.1",
    "@playwright/test": "^1.57.0",
    "@stryker-mutator/core": "^9.0.0",
    "@stryker-mutator/jest-runner": "^9.0.0",
    "@types/base-64": "^1.0.2",
    "@types/eslint-plugin-jsx-a11y": "^6.10.1",
    "@types/eslint-plugin-tailwindcss": "^3.17.0",
    "@types/fs-extra": "^11.0.0",
    "@types/jest": "^30.0.0",
    "@types/lodash.merge": "^4.6.0",
    "@types/node": "^22.0.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "baseline-browser-mapping": "^2.9.2",
    "esbuild-register": "^3.6.0",
    "eslint-config-expo": "~57.0.2",
    "eslint-config-prettier": "^10.0.0",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-functional": "^9.0.0",
    "eslint-plugin-i18next": "^6.1.5",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^61.5.0",
    "eslint-plugin-jsx-a11y": "^6.10.0",
    "eslint-plugin-oxlint": "^1.62.0",
    "eslint-plugin-prettier": "^5.5.0",
    "eslint-plugin-react": "^7.37.0",
    "eslint-plugin-react-compiler": "^19.1.0-rc.2",
    "eslint-plugin-react-hooks": "^7.0.0",
    "eslint-plugin-react-perf": "^3.3.0",
    "eslint-plugin-sonarjs": "^4.0.3",
    "eslint-plugin-tailwindcss": "^3.18.0",
    "fast-check": "^4.9.0",
    "globals": "^16.0.0",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.2.0",
    "jiti": "^2.4.0",
    "jscodeshift": "0.15.2",
    "knip": "^5.0.0",
    "lint-staged": "^16.2.7",
    "oxlint": "^1.62.0",
    "oxlint-tsgolint": "^0.24.0",
    "prettier-plugin-tailwindcss": "^0.6.5",
    "react-test-renderer": "19.2.3",
    "serve": "^14.2.0",
    "standard-version": "^9.5.0",
    "ts-jest": "^29.4.6",
    "ts-morph": "^27.0.2",
    "ts-node": "^10.9.2",
    "tsconfig-paths": "^4.2.0",
    "tsx": "^4.0.0",
    "typescript-eslint": "^8.0.0"
  },
  "scripts": {
    "build": "tsc",
    "format:check": "$npm_execpath run format:check:lisa",
    "knip:check": "$npm_execpath run knip:check:lisa",
    "lint": "oxlint && eslint . --quiet && node scripts/design-system/check-playground-coverage.mjs && node scripts/design-system/budgets.mjs && node --test scripts/design-system/__tests__/budgets.test.mjs && node scripts/design-system/figma-import-check.mjs && node scripts/design-system/figma-variable-ids-validate.mjs && node scripts/design-system/figma-files-validate.mjs && node scripts/i18n/legacy-i18n-guard.mjs && bun run check:required-checks && bun run i18n:guard:test && bun run maestro:flow-identity && bun run e2e:guard:test && bun run check-e2e-coverage:test && bun run check:bdd-evidence-titles && bun run metro:isolation:test && bun run css:isolation:test && bun run css:no-node-modules-writes && bun run rules:claims",
    "lint:slow": "$npm_execpath run lint:slow:lisa",
    "postinstall": "[ -n \"$CI\" ] || LISA_BOOTSTRAP=1 node node_modules/@codyswann/lisa/all/copy-overwrite/scripts/lisa-postinstall.mjs || true && patch-package && node scripts/fix-test-exclude.mjs && bun run generate:css",
    "sg:scan": "$npm_execpath run sg:scan:lisa && $npm_execpath run sg:test",
    "test": "NODE_ENV=test LISA_TEST_SCRATCH_PREFIXES='[\"jest_\",\"jiti\",\"node-\"]' lisa-test-run --profile expo --adapter direct -- jest",
    "test:cov": "NODE_ENV=test LISA_TEST_SCRATCH_PREFIXES='[\"jest_\",\"jiti\",\"node-\"]' lisa-test-run --profile expo --adapter direct -- jest --coverage",
    "test:cov:unit": "LISA_COVERAGE_SCOPE=unit NODE_ENV=test LISA_TEST_SCRATCH_PREFIXES='[\"jest_\",\"jiti\",\"node-\"]' lisa-test-run --profile expo --adapter direct -- jest --coverage --testPathIgnorePatterns=\"\\.integration[.\\\\-](test|spec)\\.(ts|tsx)$\"",
    "test:integration": "$npm_execpath run test:integration:lisa",
    "test:node": "LISA_TEST_SCRATCH_PREFIXES='[\"node-\",\"retry-cap-\",\"css-interop-cache\",\"jiti\",\"playwright-transform-cache\",\"pr-gate-specs\",\"rules-claims\",\"se7723\",\"se7724\",\"se7725-lint-staged\",\"se7786-reaper\",\"se7790\"]' lisa-test-run --profile expo --adapter direct -- node scripts/lisa-test-node.mjs",
    "test:unit": "NODE_ENV=test LISA_TEST_SCRATCH_PREFIXES='[\"jest_\",\"jiti\",\"node-\"]' lisa-test-run --profile expo --adapter direct -- jest --testPathIgnorePatterns=\"\\.integration[.\\\\-](test|spec)\\.(ts|tsx)$\"",
    "test:watch": "NODE_ENV=test LISA_TEST_SCRATCH_PREFIXES='[\"jest_\",\"jiti\",\"node-\"]' lisa-test-run --profile expo --adapter direct -- jest --watch",
    "typecheck": "$npm_execpath run typecheck:lisa",
    "lighthouse:check": "lhci autorun --collect.settings.chromeFlags='--no-sandbox --disable-gpu --headless' --assert.assertions.forced-reflow-insight=off && node scripts/check-lighthouse-details.mjs",
    "maestro:studio": "maestro studio",
    "maestro:test": "node scripts/lib/worktree-dependencies.mjs && lisa-test-run --profile expo --adapter direct -- maestro test .maestro/flows",
    "maestro:test:android": "node scripts/lib/worktree-dependencies.mjs && lisa-test-run --profile expo --adapter direct -- maestro test -p android .maestro/flows",
    "maestro:test:ios": "node scripts/lib/worktree-dependencies.mjs && lisa-test-run --profile expo --adapter direct -- maestro test -p ios .maestro/flows",
    "maestro:test:smoke": "node scripts/lib/worktree-dependencies.mjs && lisa-test-run --profile expo --adapter direct -- maestro test -p ios --include-tags=smoke .maestro/flows",
    "playwright:build": "expo export --platform web",
    "playwright:test": "node scripts/lib/worktree-dependencies.mjs && bun run playwright:build && lisa-test-run --profile expo --adapter direct -- playwright test",
    "playwright:test:ui": "node scripts/lib/worktree-dependencies.mjs && bun run playwright:build && lisa-test-run --profile expo --adapter direct -- playwright test --ui",
    "gates:ci-path": "node scripts/check-ci-gate-path.mjs",
    "i18n:guard": "node scripts/i18n/legacy-i18n-guard.mjs",
    "i18n:guard:test": "node --test scripts/i18n/__tests__/*.test.mjs",
    "start:local": "cp .env.localhost .env.local && STAGE=local expo start",
    "start:dev": "cp .env.development .env.local && STAGE=development expo start",
    "start:staging": "cp .env.staging .env.local && STAGE=staging expo start",
    "start:production": "cp .env.production .env.local && STAGE=production expo start",
    "fetch:graphql:sdl": "node scripts/fetch-graphql-sdl.mjs",
    "fetch:graphql:schema:dev": "./scripts/fetch-graphql-schema.sh development",
    "fetch:graphql:schema:staging": "./scripts/fetch-graphql-schema.sh staging",
    "fetch:graphql:schema:production": "./scripts/fetch-graphql-schema.sh production",
    "export:web": "expo export --platform web --source-maps",
    "maestro:flow-identity": "node scripts/maestro/check-flow-identity.mjs",
    "pre-build:eas": "cat .gitignore > .easignore && cat .easignore.extra >> .easignore",
    "android": "expo run:android",
    "ios": "expo run:ios",
    "design:manifest": "node scripts/design-system/generate-gallery-manifest.mjs",
    "design:budgets": "node scripts/design-system/budgets.mjs",
    "design:budgets:test": "node --test scripts/design-system/__tests__/*.test.mjs",
    "design:figma-import-check": "node scripts/design-system/figma-import-check.mjs",
    "design:figma-import-check:test": "node --test scripts/design-system/__tests__/figma-import-check.test.mjs",
    "design:variable-ids:validate": "node scripts/design-system/figma-variable-ids-validate.mjs",
    "design:figma-files:validate": "node scripts/design-system/figma-files-validate.mjs",
    "design:figma-files:validate:test": "node --test scripts/design-system/__tests__/figma-files-validate.test.mjs",
    "check-e2e-coverage:test": "node --test scripts/__tests__/*.test.mjs",
    "maestro:scripts:test": "node --test scripts/maestro/__tests__/*.test.mjs",
    "metro:isolation:test": "node --test scripts/metro/__tests__/*.test.mjs",
    "e2e:guard:test": "node --test scripts/e2e/__tests__/*.test.mjs scripts/maestro/__tests__/*.test.mjs scripts/environment/__tests__/*.test.mjs",
    "bdd:coverage": "node scripts/check-bdd-coverage.mjs",
    "bdd:contract": "node scripts/check-bdd-contract-ratchet.mjs",
    "bdd:contract:update": "node scripts/check-bdd-contract-ratchet.mjs --update",
    "graphql:collision-audit": "node scripts/fetch-graphql-sdl.mjs && node scripts/graphql-collision-classify.mjs",
    "graphql:collision-audit:update": "node scripts/fetch-graphql-sdl.mjs && node scripts/graphql-collision-classify.mjs --update",
    "bdd:matrix": "node scripts/bdd-matrix.mjs --write",
    "bdd:matrix:check": "node scripts/check-bdd-matrix-current.mjs",
    "check:bdd-coverage": "node scripts/check-bdd-coverage.mjs",
    "check:bdd-evidence-titles": "node scripts/check-bdd-evidence-titles.mjs",
    "design:inventory": "node scripts/design-system/inventory.mjs && node scripts/design-system/snap-tables.mjs",
    "design:figma": "node scripts/design-system/export-figma-tokens.mjs",
    "design:figma:hygiene": "node scripts/design-system/figma-hygiene.mjs",
    "design:figma:adoption": "node scripts/design-system/figma-library-adoption.mjs",
    "design:figma:gaps": "node scripts/design-system/figma-gap-report.mjs",
    "design:verify-figma": "node scripts/design-system/verify-figma.mjs",
    "design:verify-figma:update": "node scripts/design-system/verify-figma.mjs --update",
    "design:figma:report": "node scripts/design-system/figma-hygiene.mjs --write; node scripts/design-system/figma-library-adoption.mjs --write; node scripts/design-system/figma-gap-report.mjs --write",
    "design:seed-sources": "node scripts/design-system/seed-design-sources.mjs",
    "design:coverage": "node scripts/design-system/check-playground-coverage.mjs",
    "design:seal": "node scripts/design-system/seed-playground-exceptions.mjs",
    "lint:fix": "node scripts/lib/worktree-dependencies.mjs && oxlint --fix && eslint . --fix",
    "types:check": "NODE_OPTIONS=--max-old-space-size=4096 tsc --noEmit",
    "format": "node scripts/lib/worktree-dependencies.mjs && prettier --check . --write",
    "prepare": "node -e \"if (process.env.INIT_CWD?.includes('.serverless')) process.exit(0); process.exit(1);\" || husky install || true",
    "start": "node dist/index.js",
    "dev": "tsx src/index.ts",
    "update-node-version": "tsx scripts/update-node-version.ts",
    "knip:fix": "node scripts/lib/worktree-dependencies.mjs && knip --fix",
    "test:debug": "NODE_ENV=test node --inspect-brk -r tsconfig-paths/register -r ts-node/register node_modules/.bin/jest --runInBand",
    "watch:css": "node scripts/css/generate-css.cjs --watch",
    "generate:css": "node scripts/css/generate-css.cjs",
    "generate:component": "./scripts/addComponent.sh",
    "generate:feature": "./scripts/addFeature.sh",
    "generate:types:sdl": "node scripts/fetch-graphql-sdl.mjs && GRAPHQL_SDL_FILE=schema.sdl.gql DOTENV_CONFIG_PATH=.env.development graphql-codegen -r dotenv/config --config codegen.ts && GRAPHQL_SDL_FILE=schema.sdl.gql node scripts/stamp-graphql-provenance.mjs",
    "generate:types:local": "DOTENV_CONFIG_PATH=.env.localhost graphql-codegen -r dotenv/config --config codegen.ts && node --env-file=.env.localhost scripts/stamp-graphql-provenance.mjs",
    "generate:types:dev": "DOTENV_CONFIG_PATH=.env.development graphql-codegen -r dotenv/config --config codegen.ts && node --env-file=.env.development scripts/stamp-graphql-provenance.mjs",
    "generate:types:staging": "DOTENV_CONFIG_PATH=.env.staging graphql-codegen -r dotenv/config --config codegen.ts && node --env-file=.env.staging scripts/stamp-graphql-provenance.mjs",
    "generate:types:production": "DOTENV_CONFIG_PATH=.env.production graphql-codegen -r dotenv/config --config codegen.ts && node --env-file=.env.production scripts/stamp-graphql-provenance.mjs",
    "dev:instrumented": "INSTRUMENT_CODE=1 expo start --web --port 3000",
    "eas:build:local:dev": "cp .env.development .env.local && source .env.secrets && echo $SENTRY_AUTH_TOKEN && SENTRY_AUTH_TOKEN=$SENTRY_AUTH_TOKEN eas build --profile dev --local",
    "analyze:bundle": "bun run export:web && npx source-map-explorer 'dist/**/*.js'",
    "web:test": "expo start --web --port 8082 --non-interactive",
    "test:e2e": "playwright test",
    "test:e2e:single": "playwright test --workers=1",
    "e2e:cleanup": "bun run scripts/e2e/cleanup-shared-org.ts",
    "e2e:prune-matches": "node scripts/e2e/prune-e2e-matches.mjs",
    "e2e:retry-cap:coverage": "node scripts/e2e/retry-cap-coverage.mjs",
    "e2e:retry-cap:probe": "node scripts/e2e/retry-cap-probe.mjs",
    "e2e:retry-cap:test": "node --test scripts/e2e/__tests__/needs-node-modules/*.test.mjs",
    "test:local": "TEST_ENV=local playwright test",
    "test:dev": "TEST_ENV=development playwright test",
    "test:staging": "TEST_ENV=staging playwright test",
    "test:unit:watch": "jest --watch",
    "lisa:update": "lisa .",
    "build-and-run:local:android": "expo run:android",
    "build-and-run:local:ios": "expo run:ios",
    "security:zap": "bash scripts/zap-baseline.sh",
    "smoke:graphql": "tsx scripts/graphql-smoke-test.ts",
    "smoke:graphql:dev": "GQL_SMOKE_ENV=dev tsx scripts/graphql-smoke-test.ts",
    "smoke:graphql:staging": "GQL_SMOKE_ENV=staging tsx scripts/graphql-smoke-test.ts",
    "start:simulator:ios:local": "cp .env.localhost .env.local && STAGE=local expo start --ios",
    "start:simulator:ios:dev": "cp .env.development .env.local && STAGE=development expo start --ios",
    "start:simulator:ios:staging": "cp .env.staging .env.local && STAGE=staging expo start --ios",
    "start:simulator:ios:production": "cp .env.production .env.local && STAGE=production expo start --ios",
    "start:simulator:android:local": "cp .env.localhost .env.local && STAGE=local expo start --android",
    "start:simulator:android:dev": "cp .env.development .env.local && STAGE=development expo start --android",
    "start:simulator:android:staging": "cp .env.staging .env.local && STAGE=staging expo start --android",
    "start:simulator:android:production": "cp .env.production .env.local && STAGE=production expo start --android",
    "build-and-run:simulator:ios:local": "cp .env.localhost .env.local && STAGE=local expo run:ios",
    "build-and-run:simulator:ios:dev": "cp .env.development .env.local && STAGE=development expo run:ios",
    "build-and-run:simulator:ios:staging": "cp .env.staging .env.local && STAGE=staging expo run:ios",
    "build-and-run:simulator:ios:production": "cp .env.production .env.local && STAGE=production expo run:ios",
    "build-and-run:simulator:android:local": "cp .env.localhost .env.local && STAGE=local expo run:android",
    "build-and-run:simulator:android:dev": "cp .env.development .env.local && STAGE=development expo run:android",
    "build-and-run:simulator:android:staging": "cp .env.staging .env.local && STAGE=staging expo run:android",
    "build-and-run:simulator:android:production": "cp .env.production .env.local && STAGE=production expo run:android",
    "eas:login": "eas login",
    "eas:whoami": "eas whoami",
    "eas:deploy:dev": "eas build --profile dev --non-interactive",
    "eas:deploy:staging": "eas build --profile staging --non-interactive",
    "eas:deploy:production": "eas build --profile production --non-interactive",
    "eas:publish:dev": "eas update --channel dev --environment development --non-interactive",
    "eas:publish:staging": "eas update --channel staging --environment preview --non-interactive",
    "eas:publish:production": "eas update --channel production --environment production --non-interactive",
    "setup:deploy-key": "setup-deploy-key",
    "environment:reset": "node scripts/environment/reset.mjs",
    "environment:reset:verify": "node scripts/environment/reset-verify.mjs",
    "environment:reseed": "node scripts/environment/reseed.mjs",
    "environment:reseed:verify": "node scripts/environment/reseed-verify.mjs",
    "test:mutation": "node scripts/lib/worktree-dependencies.mjs && LISA_TEST_SCRATCH_PREFIXES='[\"lisa-mutation-\",\"worker-\"]' lisa-test-run --profile expo --adapter direct -- node scripts/lisa-mutation.mjs",
    "sg:test": "node scripts/lib/worktree-dependencies.mjs && ast-grep test",
    "nightly:health": "node scripts/check-nightly-e2e-health.mjs",
    "check:required-checks": "node scripts/check-required-checks-baseline.mjs",
    "check:local-load": "node scripts/local-cpu-contention-check.mjs",
    "check:required-checks:remote": "node scripts/check-required-checks-baseline.mjs --remote",
    "check:required-checks:refresh": "node scripts/check-required-checks-baseline.mjs --remote --write",
    "check:skipped-required-checks": "node scripts/check-skipped-required-checks.mjs",
    "check:vacuous-required-checks": "node scripts/check-skipped-required-checks.mjs --vacuity",
    "maestro:classify": "node scripts/classify-maestro-failures.mjs",
    "bdd:coverage:write": "node scripts/check-bdd-coverage.mjs --write",
    "start:atlas": "cp .env.development .env.local && STAGE=development EXPO_ATLAS=true expo start",
    "test:e2e:pr": "node scripts/e2e/pr-browser-gate.mjs",
    "test:e2e:pr:count": "node scripts/e2e/pr-browser-gate.mjs --count-changed",
    "test:e2e:pr:changed": "node scripts/e2e/pr-browser-gate.mjs --changed-only",
    "check:work-item": "node scripts/lisa-work-item.mjs validate-pr",
    "check:work-item:push": "node scripts/lisa-work-item.mjs validate-push",
    "lint:lisa": "node scripts/lib/worktree-dependencies.mjs && oxlint && eslint . --quiet",
    "format:check:lisa": "node scripts/lib/worktree-dependencies.mjs && prettier --check .",
    "lint:slow:lisa": "node scripts/lib/worktree-dependencies.mjs && eslint . --config eslint.slow.config.ts --quiet",
    "typecheck:lisa": "node scripts/lib/worktree-dependencies.mjs && tsc --noEmit",
    "knip:check:lisa": "node scripts/lib/worktree-dependencies.mjs && knip",
    "sg:scan:lisa": "node scripts/lib/worktree-dependencies.mjs && ast-grep scan",
    "check:conflict-markers": "node scripts/check-conflict-markers.mjs",
    "test:integration:lisa": "node scripts/lib/worktree-dependencies.mjs && NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest --testPathPatterns=\"\\.integration[.\\\\-](test|spec)\\.(ts|tsx)$\"",
    "check:verification": "node scripts/check-verification-coverage.mjs",
    "rules:claims": "node scripts/check-rules-claims.mjs",
    "rules:claims:test": "node --test scripts/__tests__/rules-claims.test.mjs",
    "test:boot": "playwright test --config playwright.boot.config.ts",
    "sonar:explain": "node scripts/sonar-explain.mjs",
    "sonar:explain:test": "node --test scripts/__tests__/sonar-explain.test.mjs",
    "css:path": "node scripts/css/generate-css.cjs --path",
    "css:check": "node scripts/css/generate-css.cjs --check",
    "css:isolation:test": "node --test scripts/css/__tests__/*.test.mjs",
    "css:no-node-modules-writes": "node scripts/css/no-node-modules-writes.mjs",
    "check:third-party-action-pins": "node scripts/check-third-party-action-pins.mjs --warn",
    "test:cov:lisa": "node scripts/lib/worktree-dependencies.mjs && NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest --coverage",
    "test:cov:unit:lisa": "node scripts/lib/worktree-dependencies.mjs && LISA_COVERAGE_SCOPE=unit NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest --coverage --testPathIgnorePatterns=\"\\.integration[.\\\\-](test|spec)\\.(ts|tsx)$\"",
    "test:lisa": "node scripts/lib/worktree-dependencies.mjs && NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest",
    "test:node:lisa": "node scripts/lib/worktree-dependencies.mjs && LISA_TEST_SCRATCH_PREFIXES='[\"node-\"]' lisa-test-run --profile expo --adapter direct -- node scripts/lisa-test-node.mjs",
    "test:unit:lisa": "node scripts/lib/worktree-dependencies.mjs && NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest --testPathIgnorePatterns=\"\\.integration[.\\\\-](test|spec)\\.(ts|tsx)$\"",
    "test:watch:lisa": "node scripts/lib/worktree-dependencies.mjs && NODE_ENV=test lisa-test-run --profile expo --adapter direct -- jest --watch"
  },
  "engines": {
    "npm": "please-use-bun",
    "yarn": "please-use-bun",
    "pnpm": "please-use-bun",
    "bun": "1.3.8",
    "node": "22.21.1"
  },
  "dependencies": {
    "@expo/html-elements": "^0.12.5",
    "@expo/metro-runtime": "~57.0.15",
    "@gluestack-ui/core": "^5.0.15",
    "@gluestack-ui/utils": "^5.0.6",
    "@gorhom/bottom-sheet": "^5.2.6",
    "@legendapp/motion": "^2.4.0",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-masked-view/masked-view": "0.3.2",
    "@sentry/react-native": "~7.11.0",
    "@shopify/flash-list": "2.0.2",
    "@shopify/react-native-skia": "2.6.4",
    "expo": "~57.0.21",
    "expo-application": "~57.0.2",
    "expo-battery": "~57.0.2",
    "expo-build-properties": "~57.0.17",
    "expo-clipboard": "~57.0.1",
    "expo-constants": "~57.0.17",
    "expo-crypto": "~57.0.2",
    "expo-dev-client": "~57.0.18",
    "expo-device": "~57.0.1",
    "expo-font": "~57.0.3",
    "expo-linear-gradient": "~57.0.1",
    "expo-linking": "~57.0.9",
    "expo-localization": "~57.0.1",
    "expo-network": "~57.0.1",
    "expo-notifications": "~57.0.17",
    "expo-router": "~57.0.20",
    "expo-secure-store": "~57.0.3",
    "expo-splash-screen": "~57.0.8",
    "expo-status-bar": "~57.0.1",
    "expo-system-ui": "~57.0.3",
    "expo-updates": "~57.0.21",
    "lucide-react-native": "^0.562.0",
    "nativewind": "^4.2.1",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "react-native": "0.86.3",
    "react-native-gesture-handler": "~2.32.0",
    "react-native-keyboard-controller": "1.21.9",
    "react-native-reanimated": "4.5.1",
    "react-native-safe-area-context": "~5.7.0",
    "react-native-screens": "~4.26.0",
    "react-native-svg": "15.15.4",
    "react-native-web": "^0.21.2",
    "react-native-worklets": "0.10.1",
    "tailwindcss": "3.4.19",
    "@apollo/client": "^3.11.3",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/modifiers": "^9.0.0",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@expo-google-fonts/inter": "^0.2.3",
    "@gorhom/portal": "1.0.14",
    "@hookform/resolvers": "^3.9.0",
    "@jam.dev/sdk": "^1.0.1",
    "@ptomasroos/react-native-multi-slider": "^2.2.2",
    "@react-native-firebase/app": "^22.4.0",
    "@react-navigation/drawer": "^7.5.0",
    "@react-navigation/elements": "^1.3.31",
    "@ronradtke/react-native-markdown-display": "^8.1.0",
    "@tanstack/react-table": "^8.21.3",
    "apollo-link-sentry": "4.4.0",
    "base-64": "^1.0.0",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "events": "^3.3.0",
    "expo-document-picker": "~57.0.1",
    "expo-file-system": "~57.0.6",
    "expo-speech-recognition": "^57.0.0",
    "graphql": "^16.12.0",
    "i18n-js": "^4.5.1",
    "i18next": "^25.10.10",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.2",
    "patch-package": "^8.0.0",
    "posthog-react-native": "^4.36.0",
    "react-hook-form": "^7.70.0",
    "react-i18next": "^16.6.6",
    "react-native-bouncy-checkbox": "^4.1.2",
    "react-native-draggable-flatlist": "^4.0.1",
    "react-native-element-dropdown": "^2.12.1",
    "react-native-gifted-chat": "2.8.1",
    "react-native-sse": "^1.2.1",
    "react-native-store-version": "^1.4.1",
    "react-native-toast-notifications": "^3.4.0",
    "react-native-webview": "13.16.1",
    "react-select": "^5.10.1",
    "tar": ">=7.5.21",
    "text-encoding-polyfill": "^0.6.7",
    "use-debounce": "^10.1.0",
    "usehooks-ts": "^3.1.1",
    "victory": "^37.1.1",
    "victory-native": "^41.4.0",
    "yup": "^1.4.0",
    "zod": "^4.3.5"
  },
  "expo": {
    "install": {
      "exclude": [
        "jest",
        "@types/jest"
      ]
    }
  },
  "main": "index.tsx",
  "resolutions": {
    "joi": "^17.13.8",
    "react-test-renderer": "$react-test-renderer",
    "tailwindcss": "$tailwindcss",
    "eslint-plugin-react-hooks": "$eslint-plugin-react-hooks",
    "handlebars": ">=4.7.9",
    "tar": "$tar",
    "send": "^0.19.0",
    "cross-spawn": "^7.0.6",
    "form-data": ">=4.0.6",
    "undici": "^6.28.0",
    "axios": ">=1.18.0",
    "tmp": ">=0.2.7",
    "lodash": ">=4.18.1",
    "rimraf": "^5.0.10",
    "image-size": "^1.2.1",
    "node-forge": ">=1.4.0",
    "test-exclude": "^7.0.1",
    "fast-xml-parser": "^5.10.1",
    "jspdf": "$jspdf",
    "@isaacs/brace-expansion": "^5.0.1",
    "basic-ftp": ">=5.3.1",
    "immutable": "^5.1.8",
    "flatted": ">=3.4.2",
    "@xmldom/xmldom": "~0.8.15",
    "launch-editor": ">=2.14.1",
    "protobufjs": "^8.4.1",
    "shell-quote": ">=1.11.0",
    "@grpc/grpc-js": ">=1.14.5",
    "esbuild": ">=0.28.1",
    "ws": ">=8.21.0",
    "vite": ">=8.0.16",
    "multer": ">=2.3.0",
    "systeminformation": ">=5.31.7",
    "websocket-driver": ">=0.7.5",
    "linkify-it": "^5.0.2",
    "fast-uri": "^3.1.3",
    "postcss": ">=8.5.18",
    "nanoid": "^3.3.18",
    "js-yaml": "^5.2.3",
    "browserslist": ">=4.28.7"
  },
  "overrides": {
    "joi": "^17.13.8",
    "tailwindcss": "$tailwindcss",
    "eslint-plugin-react-hooks": "$eslint-plugin-react-hooks",
    "handlebars": ">=4.7.9",
    "zod-validation-error": "^4.0.0",
    "tar": "$tar",
    "fast-xml-parser": "^5.10.1",
    "jspdf": "$jspdf",
    "@isaacs/brace-expansion": "^5.0.1",
    "axios": ">=1.18.0",
    "basic-ftp": ">=5.3.1",
    "immutable": "^5.1.8",
    "undici": "^6.28.0",
    "node-forge": ">=1.4.0",
    "flatted": ">=3.4.2",
    "@xmldom/xmldom": "~0.8.15",
    "launch-editor": ">=2.14.1",
    "protobufjs": "^8.4.1",
    "eslint-plugin-sonarjs": "$eslint-plugin-sonarjs",
    "tmp": ">=0.2.7",
    "lodash": ">=4.18.1",
    "shell-quote": ">=1.11.0",
    "@grpc/grpc-js": ">=1.14.5",
    "esbuild": ">=0.28.1",
    "form-data": ">=4.0.6",
    "ws": ">=8.21.0",
    "vite": "^8.0.16",
    "multer": ">=2.3.0",
    "websocket-driver": ">=0.7.5",
    "systeminformation": ">=5.31.7",
    "linkify-it": "^5.0.2",
    "fast-uri": "^3.1.3",
    "postcss": ">=8.5.18",
    "nanoid": "^3.3.18",
    "js-yaml": "^5.2.3",
    "browserslist": ">=4.28.7"
  },
  "trustedDependencies": [
    "@ast-grep/cli",
    "@codyswann/lisa",
    "@sentry/cli",
    "@shopify/react-native-skia"
  ],
  "name": "frontend-v2",
  "version": "9.64.2",
  "description": "Frontend for the Gemini Sports Platform",
  "author": "",
  "private": true,
  "license": "UNLICENSED"
}
